import type { DurationLike } from "luxon";
import { DateTime } from "luxon";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";

/**
 * Returns a sorted copy with contracts ending within `threshold` from now first, soonest end first.
 * All other contracts follow in their original order.
 */
export function sortExpiringSoonFirst<T extends { last_date?: string | null }>(
  contracts: ReadonlyArray<T>,
  threshold: DurationLike
): Array<T> {
  const now = DateTime.now();
  const latestExpiringSoon = now.plus(threshold);

  const expiringSoon: Array<{ contract: T; endMillis: number }> = [];
  const rest: Array<T> = [];

  for (const contract of contracts) {
    const end = backendDateOrDateTimeToLuxonDateTimeOrNull(
      contract.last_date
    )?.endOf("day");
    if (end && end >= now && end <= latestExpiringSoon) {
      expiringSoon.push({ contract, endMillis: end.toMillis() });
    } else {
      rest.push(contract);
    }
  }

  expiringSoon.sort((a, b) => a.endMillis - b.endMillis);

  return [...expiringSoon.map((entry) => entry.contract), ...rest];
}
